import { overviewStats } from "@/mocks/highlights";
import { dramas } from "@/mocks/dramas";

const heroPosters = [dramas[0], dramas[3], dramas[2]];

export default function Hero() {
  return (
    <section
      id="top"
      className="relative w-full overflow-hidden bg-background-100 pt-24 md:pt-32 pb-16 md:pb-24"
    >
      {/* warm ambient backdrop */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-primary-200/40 blur-[120px]"></div>
        <div className="absolute top-32 right-0 w-[380px] h-[380px] rounded-full bg-accent-200/40 blur-[120px]"></div>
        <div className="absolute inset-x-0 bottom-0 h-px bg-background-200"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
        {/* copy-first */}
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs font-label font-medium text-primary-700">
            <i className="ri-movie-2-line"></i>
            演员表 · 主演阵容 · 戏外花絮
          </span>

          <h1 className="mt-5 text-3xl sm:text-4xl md:text-5xl lg:text-[56px] font-bold leading-[1.12] text-foreground-950">
            韩剧TV演员表
            <span className="text-primary-600">全收录</span>
            <br className="hidden sm:block" />
            从角色一眼看到本人
          </h1>

          <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-600 max-w-2xl">
            这里整理韩剧TV热播剧的完整演员表与主演阵容，并跟进剧中明星的绯闻动态与幕后花絮。
            适合追剧时想深入了解演员背景、戏外八卦的你——从角色到本人，帮你一次看透。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#cast"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-list-check-2"></i>
              查看热播剧演员表
            </a>
            <a
              href="#bts"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-label font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-clapperboard-line"></i>
              先看幕后花絮
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-6 max-w-2xl">
            {overviewStats.map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <dt className="flex items-center gap-1.5 text-xs text-foreground-500 font-label">
                  <i className={`${stat.icon} text-primary-500`}></i>
                  {stat.label}
                </dt>
                <dd className="mt-1.5 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                  {stat.value}
                  <span className="ml-1 text-sm font-normal text-foreground-500">{stat.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* visual-secondary collage */}
        <div className="lg:col-span-5">
          <div className="relative mx-auto max-w-md lg:max-w-none h-[380px] sm:h-[440px]">
            <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-primary-100 via-background-50 to-accent-100"></div>
            <div className="relative h-full w-full flex items-center justify-center">
              <div className="flex items-end justify-center gap-3 sm:gap-4 translate-y-2">
                <div className="w-28 sm:w-32 h-44 sm:h-52 rounded-xl overflow-hidden -rotate-6 ring-1 ring-background-200">
                  <img
                    src={heroPosters[2].poster}
                    alt={`《${heroPosters[2].title}》剧集海报`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-36 sm:w-44 h-60 sm:h-72 rounded-xl overflow-hidden z-10 ring-2 ring-primary-200">
                  <img
                    src={heroPosters[0].poster}
                    alt={`《${heroPosters[0].title}》剧集海报`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-28 sm:w-32 h-44 sm:h-52 rounded-xl overflow-hidden rotate-6 ring-1 ring-background-200">
                  <img
                    src={heroPosters[1].poster}
                    alt={`《${heroPosters[1].title}》剧集海报`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>

            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-background-50 border border-background-200 rounded-xl px-4 py-3 flex items-center gap-3">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-fire-line"></i>
              </span>
              <div className="leading-tight">
                <p className="text-[11px] text-foreground-500 font-label">本周热度最高</p>
                <p className="text-sm font-medium text-foreground-900">《{dramas[0].title}》</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}